import React, { useEffect } from 'react';
import { useTitle } from "../../../contexts/title";
import ChangeOrderGrid from '../../../features/cfi/change-order-grid/components/ChangeOrderGrid';
import { ChangeOrderStatus } from '../../../types/enums';

export default function CustomerChangeOrdersPage() {

	const pageTitle = useTitle();
	useEffect(() => {
		pageTitle.setTitle('Pending Customer Payment')
	}, [pageTitle]);

	return (
		<React.Fragment>
			<div className={'content-block'}>
				<ChangeOrderGrid changeOrderStatus={ChangeOrderStatus.Customer} />
			</div>
		</React.Fragment>
	)
} 
